import React from "react"
import Img from "gatsby-image"
import IconsAdded from "./IconsAdded"
const caseStudyDescription = ({ caseStudyData, data }) => {
    return (
        <div className="case-study-info position-relative">
            <div className="case-study-info-container">
                <div className="margin-top-class">
                    <h1 className="bold-text">{caseStudyData.ITitle}</h1>
                    <p>{caseStudyData.Idescription}</p>
                </div>
                <div className="loop-grid">
                    <div>
                        {caseStudyData.data.map((d, index) => {
                            return (
                                <div>
                                    {d.Title === "keyReqProblem" ? (
                                        <div className=" margin-top-class">
                                            <h2 className="bold-text">Key Requirements / Problems</h2>
                                            <ul className="ul-conatiner">
                                                <li>{d.Point1}</li>
                                                {d.Point2 !== "" ? <li>{d.Point2}</li> : ""}
                                                {d.Point3 !== "" ? <li>{d.Point3}</li> : ""}
                                            </ul>
                                        </div>
                                    ) : (
                                        <div></div>
                                    )}
                                    {d.Title === "Solution" ? (
                                        <div className=" solution-conatiner">
                                            <div>
                                                <h2 className="bold-text">Our Solution/Services</h2>
                                                <p className="custom-p">{d.Sdescription}</p>
                                            </div>
                                            <div>
                                                <h2 className="bold-text">Key Value Additions</h2>
                                                <ul>
                                                    <li>{d.Point1}</li>
                                                    {d.Point2 !== "" ? <li>{d.Point2}</li> : ""}
                                                    {d.Point3 !== "" ? <li>{d.Point3}</li> : ""}
                                                </ul>
                                            </div>
                                        </div>
                                    ) : (
                                        <div></div>
                                    )}
                                </div>
                            )
                        })}
                    </div>
                    <div>
                        <Img fluid={data.secondImg.childImageSharp.fluid} />
                    </div>
                </div>
            </div>
            <div />
            <IconsAdded iconColor={"yellow"}/>
        </div>
    )
}

export default caseStudyDescription
